<div
  *ngIf="isBrowser && visible"
  class="ade-cc"
  role="dialog"
  aria-live="polite"
  [attr.aria-label]="'Cookie preferences' | transloco"
>
  <div class="ade-cc__inner">
    <div class="ade-cc__body">
      <p class="ade-cc__text">
        {{
          "We use cookies to improve your experience, analyse traffic and for marketing. You can accept all, reject non-essential, or manage your preferences."
            | transloco
        }}
        <a *ngIf="privacyHref" class="ade-cc__link" [href]="privacyHref">{{
          "Privacy Policy" | transloco
        }}</a>
        <a *ngIf="termsHref" class="ade-cc__link" [href]="termsHref">{{
          "Terms & Conditions" | transloco
        }}</a>
      </p>

      <!-- Painel de preferências -->
      <div *ngIf="expanded" class="ade-cc__prefs">
        <label class="ade-cc__row ade-cc__row--locked">
          <input type="checkbox" checked disabled />
          <span class="ade-cc__row-label">
            <strong>{{ "Necessary" | transloco }}</strong>
            <small>{{
              "Required for the site to work. Always active." | transloco
            }}</small>
          </span>
        </label>
        <label class="ade-cc__row">
          <input type="checkbox" [(ngModel)]="analytics" />
          <span class="ade-cc__row-label">
            <strong>{{ "Analytics" | transloco }}</strong>
            <small>{{
              "Helps us understand how the site is used (Google Analytics / Tag Manager)."
                | transloco
            }}</small>
          </span>
        </label>
        <label class="ade-cc__row">
          <input type="checkbox" [(ngModel)]="marketing" />
          <span class="ade-cc__row-label">
            <strong>{{ "Marketing" | transloco }}</strong>
            <small>{{
              "Used to personalise ads and measure campaigns (Meta Pixel and third-party scripts)."
                | transloco
            }}</small>
          </span>
        </label>
      </div>
    </div>

    <div class="ade-cc__actions">
      <button
        *ngIf="!expanded"
        type="button"
        class="ade-cc__btn ade-cc__btn--ghost"
        (click)="toggleExpanded()"
      >
        {{ "Manage preferences" | transloco }}
      </button>
      <button
        *ngIf="expanded"
        type="button"
        class="ade-cc__btn ade-cc__btn--ghost"
        (click)="savePrefs()"
      >
        {{ "Save preferences" | transloco }}
      </button>
      <button
        type="button"
        class="ade-cc__btn ade-cc__btn--ghost"
        (click)="rejectAll()"
      >
        {{ "Reject all" | transloco }}
      </button>
      <button
        type="button"
        class="ade-cc__btn ade-cc__btn--gold"
        (click)="acceptAll()"
      >
        {{ "Accept all" | transloco }}
      </button>
    </div>
  </div>
</div>
